/*
 * Copyright 2026 Collaterate. All rights reserved.
 */

// TTI-20903 / TTI-24096: the stock product page's variant photo events, raised the same way by both engines,
// configureStockController.js and configureStockController_Comet.js. Documented in
// docs/theme/variant-images-theme-handoff.md.
(function (window) {
    'use strict';

    window.stockVariantEvents = {
        announce: function (variantId) {
            this.raise('PRODUCT_VARIANT_CHANGED', { variantId: variantId });
        },

        ignore: function (variantId, reason) {
            var detail = Array.isArray(variantId) ? { variantIds: variantId } : { variantId: variantId };
            detail.reason = reason;
            this.raise('PRODUCT_VARIANT_SELECT_IGNORED', detail);
        },

        // window.events carries no payload, so the detail rides a collaterate:* CustomEvent beside it.
        raise: function (constantName, detail) {
            var bus = window.events;
            if (!bus || !bus[constantName]) {
                return;
            }
            bus.trigger(bus[constantName]);
            document.dispatchEvent(new CustomEvent('collaterate:' + bus[constantName], {
                detail: detail,
                bubbles: true
            }));
        },

        // Calls select(variantId) for each STOREFRONT_SELECT_VARIANT a theme triggers, however often the page initializes.
        // A photo of several variants sends { variantIds }, and select gets the list.
        listen: function (select) {
            var hub = window.tbg && window.tbg.eventHub;
            if (hub && !this.listening) {
                this.listening = true;
                hub.on(hub.events.STOREFRONT_SELECT_VARIANT, function (event, data) {
                    var many = data && Array.isArray(data.variantIds) && data.variantIds.length ? data.variantIds : null;
                    select(many || (data && data.variantId));
                });
            }
        },

        // The enabled variant a select names, or null after saying why it is ignored. A disabled variant cannot be
        // bought, so its photo stays in the carousel but never selects it. Of several, the one sharing the most
        // choices with the chosen variant, so choosing the red photo keeps the size.
        resolve: function (variants, variantIds, selectedVariantId) {
            var wanted = [].concat(variantIds).map(Number);
            var candidates = (variants || []).filter(function (v) {
                return v.enabled && wanted.indexOf(v.id) >= 0;
            });
            if (!candidates.length || candidates.some(function (v) { return v.id === selectedVariantId; })) {
                this.ignore(variantIds, candidates.length ? 'alreadySelected' : 'unknownVariant');
                return null;
            }
            var selected = (variants || []).find(function (v) {
                return v.id === selectedVariantId;
            });
            var shared = function (v) {
                var count = 0;
                for (var n = 1; n <= 3; n++) {
                    var choice = v['attribute' + n + 'Choice'];
                    if (selected && choice && choice === selected['attribute' + n + 'Choice']) {
                        count++;
                    }
                }
                return count;
            };
            return candidates.reduce(function (best, v) {
                return shared(v) > shared(best) ? v : best;
            });
        }
    };
}(window));
